"use client";

import { ComponentType, FC, PropsWithChildren } from "react";
import { ErrorBoundary as RollbarErrorBoundary } from "@rollbar/react";

import { getConfig } from "../../../_configs/AppConfig";

const { publicRuntimeConfig } = getConfig();

const DefaultFallbackUI = ({ error, resetError }) => {
  if (publicRuntimeConfig.APP_ENV === "dev") {
    console.error("error: ", error);
    console.error("resetError: ", resetError);
  }
  return (
    <div className="sb-error-inside-block" style={{ padding: "1rem" }}>
      <span className="sb-error-inside-block-icon far fa-frown" />
      <div className="sb-error-inside-block-header">
        <h2>Oops, there was an error!</h2>
      </div>
      <p className="sb-error-inside-block-message">
        Don&#39;t worry, we&#39;re on it. The error has been logged and
        we&#39;ll work hard to fix it.
      </p>
    </div>
  );
};

export const ErrorBoundary: FC<
  PropsWithChildren<{
    fallbackUI?: ComponentType<{
      error: Error | null;
      resetError: () => void;
    }>;
    userGenerated?: boolean;
  }>
> = (props) => {
  const extra = {
    user_generated: props.userGenerated ? "true" : "false",
  };

  return (
    <RollbarErrorBoundary
      fallbackUI={props.fallbackUI || DefaultFallbackUI}
      extra={extra}
    >
      {props.children}
    </RollbarErrorBoundary>
  );
};
